/* eslint-disable import/prefer-default-export */
export const getParentElementByClass = (element, selector) => {
	for (; element && element !== document; element = element.parentNode) {
		if (element.classList.contains(selector)) {
			return element;
		}
	}

	return null;
};
